(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.contact-content__form').forEach((form) => {
    form.addEventListener('submit', () => {
      const firstName = form.querySelector('[data-contact-first-name]')?.value?.trim() || '';
      const lastName = form.querySelector('[data-contact-last-name]')?.value?.trim() || '';
      const fullNameInput = form.querySelector('[data-contact-full-name]');

      if (fullNameInput) {
        fullNameInput.value = [firstName, lastName].filter(Boolean).join(' ');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
